import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-referred-faq-collapse',
  templateUrl: './referred-faq-collapse.component.html',
  styleUrls: ['./referred-faq-collapse.component.sass']
})
export class ReferredFaqCollapseComponent implements OnInit {
  @Input() content;
  constructor() { }

  ngOnInit() {
  }
  updateExpand(index){
    let content:any=this.content;
    content.content[index].expand=!content.content[index].expand;
  }
}
